
import { createApp } from './createApp'
import { v4 as uuidv4 } from 'uuid';
import { encrypt } from '../utils/tools.js'

import { EventEmitter } from '../EventEmitter'

import iframe from './element/iframe'
/**
 * @class APPLICATION
 * @classdesc 创建应用
 */
export default class Application extends EventEmitter {

    // 已创建的web组件
    elements = [];

    IframeContainer = null;
    // 等候消息列队
    sendIframeMsgList = [];

    constructor(proc) {
        super();
        this.proc = proc;
        this.data = proc.data;
        this.actions = []; //活动的应用
        this.Applications = {}; //所有注册的应用
        this.windows = {} //打开的窗口
        this.windowMsgCallback = null; //等待通信的窗口
        this.srcList = proc.data.srcList || []
        window.addEventListener('beforeunload', this.pageUnload.bind(this))


        // 载入容器及向发送消息
        iframe()
    }



    // 页面卸载事件
    pageUnload(event) {
        // event.preventDefault();
        this.closeAll();
        // event.returnValue = '这将关闭所有已打开的窗口';
    }
    loaded = false;
    /**
     * 解密应用并运行
     */
    decryptApp() {
        window.addEventListener('DOMContentLoaded', () => {
            this.loaded = true;
            this.openDecryptPage()
        })
    }

    openDecryptPage() {
        let windowApp = this.proc.getLinkAppName();

        if (windowApp) {
            let token = this.proc.data.token;
            if (!token) return;
            this.windowAppName = windowApp
            // 等待应用注册完成运行应用
            this.on('application.register', (matedata) => {
                if (matedata.name == this.windowAppName && this.asyncApps) {
                    this.run(this.windowAppName);
                }
            })

            this.run(this.windowAppName);
            this.listenStorages(this.windowAppName);
        }
    }

    /**
     * 注册app
     * @method register
     * @param {Object} matedata 
     * @param {Function} callback 
     * @returns {Object} this.Applications
     */
    register(matedata, callback) {
        if (this.hasApplication(matedata.name)) {
            return this.Applications[matedata.name];
        }

        let app = new createApp(matedata, this.proc, this.Applications);
        // callback && callback(app)
        this.Applications[matedata.name] = {
            matedata,
            app: app,
            callback: callback
        }
        this.proc.data.Application = this.Applications;
        this.emit('application.register', matedata)
        return this.Applications[matedata.name];
    }

    /**
     * 批量注册app
     * @param {Array} matedatas 
     * @param {Array<Function>} callback
     */
    registerAll(matedatas, callbacks) {
        matedatas.forEach((matedata, index) => {
            let launch = metadata.launch;
            if (launch) {
                this.register(matedata, callbacks[index]);
            }
        })
    }

    //应用启动超时
    openTimeout = 10000
    /**
     * 运行app
     * @method run
     * @param {string} appName 应用名称
     * @param {Function} successFunc 启动成功回调
     * @param {Function} errFunc 启动失败回调
     * @param { Promise<Function> } componentUrl
     */
    async run(appName, param = {}, successFunc, errFunc) {

        let packageComponent = this.getAsyncApp(appName);
        // 打开异步应用包
        if (packageComponent && typeof packageComponent.package === 'function') {
            try {
                let result = await packageComponent.package();
                result && result.default(this)
            } catch (error) {
                console.log(error)
                console.warn('load module fail')
                errFunc && errFunc(error);
                return;
            }
        }
        if (!this.hasApplication(appName)) {
            console.warn(`application ${appName} is not register`)
            errFunc && errFunc(`application ${appName} is not register`);
            return false;
        }
        let appState = this.Applications[appName];

        let url = window.location.href.split('@OPEN')[0];
        // 加密链接
        let encryptUrl = url + '@OPEN' + encrypt.encrypt(appName, this.proc.key);

        // 设置用于iframe的url
        // param.url = !param.url?encryptUrl:param.url;

        let width = 1920, height = 1080;
        if (param?.style) {
            width = param.style.width;
            height = param.style.height
        }


        // 新窗口打开
        if (param?.newWindow) {


            let before = appState.app.before ? appState.app.before() : true;
            if (!this.proc.data.token || !before) return;
            // 如果已存在打开的窗口，会关闭之前的窗口
            if (appState.app.singleton && this.windows[appName]) {
                this.windows[appName].close()
            }
            let openWindow = window.open(encryptUrl, param.windowName || '', `toolbar=0,menubar=0,status=0,location=0,scrollbars=0,resizable=no,titlebar=0,width=${width}px,height=${height}px`);
            this.windows[appName] = openWindow;
            appState.app.active = true;
            this.emit('application.run', appState.app);
            successFunc && successFunc(appState.app)
            return openWindow;
        }

        let title = appState.matedata.title || appState.matedata.alias;
        if (title) {
            document.title = title;
        }

        // 应用是否已经运行
        if (appState.app.active) {
            return appState.app;
        }
        appState.callback(appState.app);
        if (param && param.openInIframe) {
            appState.app.openIframe(encryptUrl, param);
            successFunc && successFunc(appState.app)
            return appState.app;
        }
        //  调用应用的open方法打开应用
        appState.app.open(param);
        successFunc && successFunc(appState.app)
        this.emit('application.run', appState.app)
        return appState.app;
    }

    /**
     * 开启或关闭应用
     * @method toggle
     * @param {string} appName 
     * @param {object} param 
     * @returns {appState}
     */
    toggle(appName, param) {
        if (!this.hasApplication(appName)) {
            console.warn(`application ${appName} is not register`)
            return;
        }
        let appState = this.Applications[appName];
        this.emit('application.toggle', appState.app)
        if (!appState.app.active) {
            appState.callback(appState.app);
        }
        appState.app.toggle(param);
        return appState.app;
    }

    /**
     * 获取所有app
     * @returns {Object} Applications
     */
    getApps() {
        let apps = {};
        Object.keys(this.Applications).forEach(key => {
            if (this.Applications[key].matedata.category !== "system") {
                apps[key] = this.Applications[key]
            }
        })
        return apps
    }

    hasApplication(appName) {
        return this.Applications.hasOwnProperty(appName);
    }

    destroy(appName) {
        if (this.hasApplication(appName)) {
            console.warn(`application ${appName} is already register`)
            return;

        }
        this.Applications[appName].app.destroy && this.Applications[appName].app.destroy();
        delete this.Applications[appName];
    }

    /**
     * 跨窗口通信,从一个窗口向另一个窗口发送信息
     * @param {string} appName 
     * @param {object} data 
     * @returns {void}
     */
    sendMsg(appName, data) {
        if (!this.hasApplication(appName)) return;
        let obj = {
            appname: appName,
            data: data,
            _id: uuidv4()
        }
        this.broadcast(appName, JSON.stringify(obj))
    }
    /**
     * 接收来自其他窗口的信息
     * @param {function} callback 
     * @returns {void}
     */
    receiveMsg(callback) {
        this.windowMsgCallback = callback;
    }

    /**
     * @private
     * @param {string} appname 
     */
    listenStorages(appname) {

        this.onmessage(appname, (event) => {
            this.windowMsgCallback && this.windowMsgCallback(JSON.parse(event.data || '{}'));
        })
    }


    broadcastEventList = new Map()

    /**
     * 
     * @param {string} Channel 广播频道名称
     * @param {any} msg 要广播的内容
     * 
     */
    broadcast(Channel, msg) {
        let bc = this.broadcastEventList.get(Channel)
        if (!bc) {
            bc = new BroadcastChannel(Channel);
        }
        this.broadcastEventList.set(Channel, bc)
        bc.postMessage(msg);
        return bc;
    }

    /**
     * 
     * @param {string} Channel 广播频道的内容
     * @param {function} callback 回调
     * @param {function} err 错误回调
     * @returns {BroadcastChannel}
     */
    onmessage(Channel, callback, err) {
        let bc = this.broadcastEventList.get(Channel)
        if (!bc) {
            bc = new BroadcastChannel(Channel);
        }
        bc.onmessage = callback && callback;
        bc.onmessageerror = err && err;
        return bc;
    }

    /**
     * 关闭频道
     * @param {string} Channel 
     */
    offBroadcast(Channel) {
        if (Array.isArray(Channel)) {
            Channel.forEach(item => {
                let bc = this.broadcastEventList.get(item)
                if (bc) {
                    bc.close()
                    this.broadcastEventList.delete(item)
                }
            })
            console.log(this.broadcastEventList)
            return;
        }
        let bc = this.broadcastEventList.get(Channel)
        if (bc) {
            bc.close()
            this.broadcastEventList.delete(Channel)
        }
    }

    // 是否是openWindow应用
    isOpenWindow(appName) {
        return this.windows.hasOwnProperty(appName);
    }

    hide(appName) {
        if (this.hasApplication(appName)) {
            Object.keys(this.Applications).forEach(key => {
                if (key === appName) {
                    this.Applications[key].app.hide();
                }
            })
        }
    }
    show(appName) {
        if (this.hasApplication(appName)) {
            if (!this.Applications[appName].app.active) {
                this.run(appName)
            } else {
                Object.keys(this.Applications).forEach(key => {
                    if (key === appName) {
                        this.Applications[key].app.show();
                    }
                })
            }

        }
    }

    /**
     * 关闭应用
     * @param {string} appName 
     */
    close(appName) {
        if (this.isOpenWindow(appName)) {
            this.windows[appName].close();
            delete this.windows[appName];
        }
        if (this.hasApplication(appName)) {
            Object.keys(this.Applications).forEach(key => {
                if (key === appName) {
                    this.emit('application.close', this.Applications[key].app)
                    this.Applications[key].app.close();
                }
            })
        }
    }

    destroyAll() {
        Object.keys(this.Applications).forEach(key => {
            delete this.Applications[key]
        })
    }

    closeAll() {
        Object.keys(this.Applications).forEach(key => {
            this.Applications[key].app.close();
        })
    }

    // 所有异步加载的包
    asyncPackages = []
    // 获取异步加载的应用
    getAsyncApp(name) {
        for (let i = 0, len = this.asyncPackages.length; i < len; i++) {
            let names = this.asyncPackages[i].names;
            if (Array.isArray(names) && names.includes(name)) {
                return this.asyncPackages[i];
            }
        }
        return null;
    }

    packages = [];
    installed = false;

    /**
     * @typedef installAppObj
     * @type {(object)}
     * @property {Array<string>} name 
     * @property {Function} package
     */

    /**
     * @typedef installAppPromise
     * @type {Promise}
     * @returns {Function}
     */
    /**
     * @typedef installAppFunc
     * @type {Function}
     * 
     */

    /**
     * 
     * 安装子应用
     * @param {Array<installAppObj|installAppPromise|installAppFunc>} app 安装的应用
     * @return {Promise<boolean>}
     */
    install(app) {

        this.asyncApps = false;
        this.packages = app;
        if (!Array.isArray(app)) return;
        for (let [index, item] of app.entries()) {
            if (!item) continue;
            // 普通的异步加载
            if (Object.prototype.toString.call(item) === '[object Promise]') {
                item.then(result => {
                    this.asyncApps = true;
                    result.default(this)

                })
                    .catch(err => {
                        console.warn(err)

                    })
            } else if (Object.prototype.toString.call(item) === '[object Object]') {
                // 判断使用链接加载的子应用
                if (item.url && item.name) {
                    this.srcList.push(item)
                    this.proc.data.srcList = this.srcList;
                }
                // 有条件的异步加载
                this.asyncPackages.push(item)
            } else {
                // 直接安装
                item && item(this)
            }
            this.emit('application.install', [index, item])
        }
        this.installed = true;
        this.emit('application.installed', this.packages)

    }

}